/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { REACT_APP_MAINTENANCE_TIME_FRAME } from '../constants/settings';

const timeWindowRegex = /^(?:[01]\d|2[0-3]):(?:[0-5]\d)-(?:[01]\d|2[0-3]):(?:[0-5]\d)$/;

const getSuggestedTimeString = (): {
  randomHour: number;
  randomMinute: number;
} => {
  const timeFrame = timeWindowRegex.test(REACT_APP_MAINTENANCE_TIME_FRAME)
    ? REACT_APP_MAINTENANCE_TIME_FRAME
    : '00:00-23:59';
  const [startTime, endTime] = timeFrame.split('-');
  const [startHour, startMinute] = startTime.split(':').map(Number);
  const [endHour, endMinute] = endTime.split(':').map(Number);

  const startTotalMinutes = startHour * 60 + startMinute;
  const endTotalMinutes = endHour * 60 + endMinute;
  const timeRange = endTotalMinutes - startTotalMinutes;

  const randomMinutes = Math.floor(Math.random() * timeRange);
  const randomTotalMinutes = startTotalMinutes + randomMinutes;
  const randomHour = Math.floor(randomTotalMinutes / 60);
  const randomMinute = randomTotalMinutes % 60;
  return { randomHour: randomHour, randomMinute: randomMinute };
};

export { getSuggestedTimeString };
